export default "__VITE_ASSET__DiADomPC__"